export function connectionPath(resourceKey: string) {
  const [provider, id] = resourceKey.split(':')
  return `/cc/connections/${encodeURIComponent(provider)}/${encodeURIComponent(id)}`
}
